<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="10">
          <a-col :md="7" :sm="24">
            <a-form-item label="Query">
              <a-input v-model="queryParam.name" placeholder="Name / Number" @keyup.enter.stop="refreshCurrentPage"/>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24">
            <a-form-item label="Gender">
              <a-select v-model="queryParam.gender" placeholder="Please select" default-value="0" @change="refreshCurrentPage">
                <a-select-option value="">All</a-select-option>
                <a-select-option value="M">Male</a-select-option>
                <a-select-option value="F">Female</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="24">
            <a-form-item label="Company">
              <a-select v-model="queryParam.companyCode" placeholder="Please select" default-value="0" @change="refreshCurrentPage">
                <a-select-option value="">All</a-select-option>
                <a-select-option v-for="i in companyList" :key="'company-' + i.code" :value="i.code">{{ i.enName }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="!advanced && 8 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="$refs.table.refresh(true)">Search</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = { name: '', gender: '', companyCode: '' }">Clear</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleEdit()" :disabled="!$auth('CDB_CUSTOMER_ADD')">New</a-button>
    </div> -->

    <s-table
      ref="table"
      size="default"
      rowKey="id"
      showQuickJumper
      :columns="columns"
      :data="loadData"
      :scroll="{ x: 1100 }"
    >
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
      <div slot="writeDate" slot-scope="text, record" style="display: flex;">
        <div style="font-weight:500;margin-right: 6px;">{{ record.changeBy.userName }}</div>
        <div style="width: 80px;">{{ DateTimeUtil().localString(record.writeDate !== null ? record.writeDate : record.createDate) }}</div>
      </div>
      <span slot="action" slot-scope="text, record">
        <template>
          <a-popconfirm
            title="Are you sure delete?"
            @confirm="handleRecovery(record)"
            okText="Yes"
            cancelText="No"
          >
            <a href="javascript:;" :disabled="!$auth('CDB_CUSTOMER_TRASH')" :loading="recoveryLoading">Recovery</a>
          </a-popconfirm>
          <a-divider type="vertical" />
        </template>
        <a-dropdown>
          <a class="ant-dropdown-link"><a-icon type="down" /></a>
          <a-menu slot="overlay">
            <a-menu-item>
              <!-- :disabled="record.joinTourTotal === 0 && record.joinTourCancelTotal === 0"  -->
              <a href="javascript:;"><a @click="showMergeToModal(record)">Merge To</a></a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </s-table>
    <a-modal
      title="Merge Join Tour Record To Other Customer"
      :visible="mergeToRecord !== null"
      :confirm-loading="mergeToLoading"
      @ok="handleMergeToConfirm"
      @cancel="handleMergeToCancel"
    >
      <a-form-model
        ref="mergeToForm"
        :model="mergeToForm"
        :rules="mergeToRules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="Customer code" prop="targetCustomerCode">
          <a-input placeholder="Customer Number" v-model="mergeToForm.targetCustomerCode"/>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
import moment from 'moment'
import STable from '@/components/table/'
import { toSTablePage } from '@/utils/util'
import CDBApi from '@/api/api-cdb-customer'
import { Company } from '@/utils/helper/standard-code-utils'

export default {
  name: 'CdbCustomerList',
  components: {
    STable
  },
  data () {
    return {
      companyList: Company.dict,
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: { name: '', gender: '', companyCode: '' },
      // 表头
      columns: [
        {
          title: '#',
          scopedSlots: { customRender: 'serial' },
          width: '50px',
          fixed: 'left'
        },
        {
          title: 'Number',
          dataIndex: 'customerCode',
          width: '120px',
          fixed: 'left'
        },
        {
          title: 'Name',
          dataIndex: 'fullName'
        },
        {
          title: 'Gender',
          width: '80px',
          dataIndex: 'gender',
          customRender: (value) => (value === 'M') ? 'Male' : 'Female'
        },
        {
          title: 'DOB',
          dataIndex: 'birthday',
          width: '110px',
          customRender: (value) => this.dateFormatB(value)
        },
        {
          title: 'Company',
          width: '100px',
          dataIndex: 'companyCode'
        },
        {
          title: 'Join',
          width: '80px',
          dataIndex: 'joinTourTotal'
        },
        // {
        //   title: 'Change By',
        //   dataIndex: 'changeBy',
        //   customRender: (value) => value ? value.userName : ''
        // },
        // {
        //   title: 'Change Time',
        //   dataIndex: 'writeDate',
        //   customRender: (value, record) => this.DateTimeUtil().localString(value !== null ? value : record.createDate)
        // },
        {
          title: 'Last Modified',
          dataIndex: 'writeDate',
          scopedSlots: { customRender: 'writeDate' },

        },
        {
          title: 'Action',
          dataIndex: 'action',
          width: '140px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        parameter.curPage = parameter.pageNo
        return CDBApi.queryTrash(Object.assign(parameter, this.queryParam))
          .then(res => {
            return toSTablePage(res.data)
          })
      },
      selectedRowKeys: [],
      selectedRows: [],
      recoveryLoading: false,
      // 合并团操作
      labelCol: { span: 7 },
      wrapperCol: { span: 12 },
      mergeToRecord: null,
      mergeToLoading: false,
      mergeToForm: { targetCustomerCode: null },
      mergeToRules: {
        targetCustomerCode: [{ required: true, message: 'Please input target customer code.' }],
      },
    }
  },
  created () {
  },
  methods: {
    async handleRecovery (record) {
      this.recoveryLoading = true
      try {
        const res = await CDBApi.recovery(record.id)
        if (!this.mixinProcessHasBizErrorNotification(res)) {
          this.refreshCurrentPage()
          this.mixinProcessSuccessNotification('Save successfully !')
        }
        this.recoveryLoading = false
      } catch(e) {
        console.log(e)
        this.recoveryLoading = false
      }
    },
    // 合并团操作
    showMergeToModal (record) {
      this.mergeToRecord = record
      this.mergeToForm = { targetCustomerCode: null }
    },
    handleMergeToConfirm () {
      this.$refs.mergeToForm.validate(async (valid) => {
        if (valid) {
          this.mergeToLoading = true
          try {
            const res = await CDBApi.mergeJoinToOtherCustomer(this.mergeToRecord.id, this.mergeToForm.targetCustomerCode)
            if (!this.mixinProcessHasBizErrorNotification(res)) {
              this.mixinProcessSuccessNotification('Merge successfully !')
              this.refreshCurrentPage()
              this.handleMergeToCancel()
            }
            this.mergeToLoading = false
          } catch (e) {
            this.mergeToLoading = false
            if (e && e.response && e.response.data) {
              this.$notification['error']({
                message: 'Error',
                description: `${e.response.data.errorMessage}`
              })
            }
          }
        }
      })
    },
    handleMergeToCancel () {
      this.mergeToRecord = null
      this.mergeToForm = { targetCustomerCode: null }
    },
    //
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    refreshCurrentPage () {
      this.$refs.table.refresh(false)
    },
    resetSearchForm () {
      this.queryParam = {
        date: moment(new Date())
      }
    }
  },
  watch: {
    '$route.path' () {
      this.record = ''
      this.currentComponet = 'List'
    }
  }
}
</script>
<style lang="less" scoped>
::v-deep .table-page-search-wrapper .ant-form-inline .ant-form-item > .ant-form-item-label {
  padding-right: 0;
}
::v-deep .ant-table-thead > tr > th, .ant-table-tbody > tr > td {
  padding: 14px;
}
</style>